import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
// Constants
import constants from "./constants/api.helpers.constants";
// Types

var addQueryParams = function addQueryParams(_ref) {
  var queryParams = _ref.queryParams;
  return queryParams ? "?".concat(new URLSearchParams(queryParams).toString()) : '';
};
var replacePathParams = function replacePathParams(_ref2) {
  var pathParams = _ref2.pathParams,
    url = _ref2.url;
  return url.split('/').map(function (urlUnit) {
    return urlUnit.startsWith(':') ? pathParams[urlUnit.slice(1)] : urlUnit;
  }).join('/');
};
var getBaseHost = function getBaseHost(endpoint) {
  return constants.SSS_PATHNAME.some(function (path) {
    return endpoint.includes(path);
  }) ? window.API_AUTH_BASE_HOST : window.API_BASE_HOST;
};
var buildFetchUrl = function buildFetchUrl(_ref3) {
  var absoluteUrl = _ref3.absoluteUrl,
    endpoint = _ref3.endpoint,
    pathParams = _ref3.pathParams,
    queryParams = _ref3.queryParams;
  var queriedParams = addQueryParams({
    queryParams: queryParams
  });
  var url = absoluteUrl || "".concat(getBaseHost(endpoint)).concat(endpoint);
  url = replacePathParams({
    pathParams: pathParams,
    url: url
  });
  return "".concat(url).concat(queriedParams);
};
var parseResponseBody = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(request) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          if (!(request.headers.get('Content-Type') === 'application/CSV')) {
            _context.next = 7;
            break;
          }
          _context.next = 4;
          return request === null || request === void 0 ? void 0 : request.text();
        case 4:
          return _context.abrupt("return", _context.sent);
        case 7:
          if (!(request.headers.get('Content-Type') === 'application/pdf' || request.headers.get('Content-Type') === 'application/octet-stream')) {
            _context.next = 13;
            break;
          }
          _context.next = 10;
          return request === null || request === void 0 ? void 0 : request.blob();
        case 10:
          return _context.abrupt("return", _context.sent);
        case 13:
          _context.next = 15;
          return request === null || request === void 0 ? void 0 : request.json();
        case 15:
          return _context.abrupt("return", _context.sent);
        case 16:
          _context.next = 21;
          break;
        case 18:
          _context.prev = 18;
          _context.t0 = _context["catch"](0);
          return _context.abrupt("return", {});
        case 21:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 18]]);
  }));
  return function parseResponseBody(_x) {
    return _ref4.apply(this, arguments);
  };
}();
export { buildFetchUrl, parseResponseBody };